import * as React from 'react';
import clsx from 'clsx';
import ImageLightBox from 'react-image-lightbox';

import './style.scss';
import 'react-image-lightbox/style.css';
import { getOmjsProjectInstance } from 'selectors';
import { IObjectFieldValueFile } from 'types/omjs/project';

export interface IImagesListProps {
    images: omjs.IObjectFieldValueFile[];
    className?: string;
}
export interface IImagesListState {
    lightbox_slide_index: number;
    lightbox_opened: boolean;
}

class ImagesListComponent extends React.Component<IImagesListProps, IImagesListState> {
    private project = getOmjsProjectInstance(false);

    constructor(props: IImagesListProps) {
        super(props);

        this.state = {
            lightbox_slide_index: 0,
            lightbox_opened: false
        };
    }

    getResizedUrlIcon(i: IObjectFieldValueFile) {
        return `${this.project.options.apiUrl}image/${i.uuid}/?h=95`;
    }

    render() {
        let { images } = this.props;
        let { lightbox_slide_index, lightbox_opened } = this.state;

        if (!images.length) {
            return null;
        }

        let image_paths = images.map(i => i.path);

        return (
            <div className={clsx('object-images-container', this.props.className)}>
                {images.map((i, index) => (
                    <div className="image-item" key={i.id}>
                        <a
                            href={i.path}
                            target='_blank'
                            rel='noopener noreferrer'

                            style={{
                                backgroundImage: `url(${this.getResizedUrlIcon(i)})`
                            }}
                            onClick={(e) => {
                                e.preventDefault();

                                this.setState({
                                    lightbox_opened: true,
                                    lightbox_slide_index: index
                                });
                            }}
                        />
                    </div>
                ))}

                {lightbox_opened && (
                    <ImageLightBox
                        mainSrc={image_paths[lightbox_slide_index]}
                        nextSrc={image_paths[(lightbox_slide_index + 1) % image_paths.length]}
                        prevSrc={image_paths[(lightbox_slide_index + image_paths.length - 1) % image_paths.length]}
                        onCloseRequest={() => this.setState({
                            lightbox_opened: false
                        })}
                        onMovePrevRequest={() => this.setState({
                            lightbox_slide_index: (lightbox_slide_index + image_paths.length - 1) % image_paths.length
                        })}
                        onMoveNextRequest={() => this.setState({
                            lightbox_slide_index: (lightbox_slide_index + 1) % images.length
                        })}
                        enableZoom={false}
                    />
                )}
            </div>
        );
    }
}

export const ImagesList = ImagesListComponent;
